import React from "react";
import { COMPONENT_TYPES } from "@/helpers/constants";
import BannerWithDesc from "@/components/ToolsPage/components/BannerWithDesc";
import ContentImageDescComponent from "@/components/PagePiller/components/ContentImageDesc";
import QuotesCards from "@/components/QuotesCard";
import CalculatorForm from "src/components/ToolsPage/components/CalculatorForm";
import styles from "./Tool.module.scss";

interface ComponentMappingProps {
  data: any;
  extras?: { [key: string]: any };
}

const ToolsComponentMapping = (props: ComponentMappingProps): React.ReactElement => {
  const { data, extras = {} } = props;
  const { userAgent, toolSlug } = extras;
  const type = data.ComponentType;

  switch (type) {
    case COMPONENT_TYPES.BannerWithDesc:
      return <BannerWithDesc data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.ContentImageDesc:
      return <ContentImageDescComponent data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.ToolsCalculator:
      return (
        <div className="container">
          <CalculatorForm data={data} userAgent={userAgent} toolSlug={toolSlug} />
        </div>
      );
    case COMPONENT_TYPES.Quote:
      return (
        <div className={` ${styles.quoteWrap} spacingBetweenSections`}>
          <QuotesCards data={data} />
        </div>
      );
    default:
      return null;
  }
};

export default ToolsComponentMapping;
